<template>
  <div
    id="results-menu"
    class="results-menu"
  >
    <m-button
      @click="open = !open"
      @mouseover="handleDocumentClick(this)"
    >
      <span>{{ $t('menu.results') }}</span>
    </m-button>
    <drop-board
      position="bottom"
      v-show="open"
    >
      <m-button
        dark
        class="list-item"
        @click="click('results')"
      >
        <span class="list-item-name">{{ $t('menu.sports') }}</span>
      </m-button>
      <m-button
        dark
        class="list-item"
        @click="click('resultslive')"
      >
        <span class="list-item-name">{{ $t('menu.live') }}</span>
      </m-button>
    </drop-board>
  </div>
</template>

<script>
import IResults from 'vue-material-design-icons/AccountCircle'
import IClover from 'vue-material-design-icons/Clover'
import ICreditCard from 'vue-material-design-icons/CreditCard'
import IResultsDetails from 'vue-material-design-icons/AccountDetails'
import IWalletGiftcard from 'vue-material-design-icons/WalletGiftcard'
import IExitToApp from 'vue-material-design-icons/ExitToApp'
import MButton from '@/components/buttons/MButton'
import IconButton from '@/components/buttons/IconButton'
import DropBoard from '@/components/Drop'

export default {
  components: {
    DropBoard,
    MButton,
    IconButton,

    IResults,
    IClover,
    ICreditCard,
    IResultsDetails,
    IWalletGiftcard,
    IExitToApp
  },
  data () {
    return {
      open: false,
      updateInterval: null
    }
  },
  mounted () {
    document.addEventListener('click', this.handleDocumentClick.bind(this))
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleDocumentClick)
    clearInterval(this.updateInterval)
  },
  methods: {
    handleDocumentClick (event) {
      let target = event.target || event.srcElement
      if (!target.closest('#results-menu')) {
        this.open = false
      }
    },
    click (action) {
      this.open = false
      if (action === 'results') {
        this.$router.push('/results/date/' + (new Date(Date.now() + 3600000 * 3)).toISOString().split('T')[0])
      } else {
        this.$router.push(`/${action}`)
      }
    }
  }
}
</script>

<style scoped>
.results-menu {
  color: #fff;
  font-size: 14px !important;
  height: 50px;
  line-height: 50px !important;
  padding: 0 10px;
  font-weight: 700 !important;
}
.icon-button { color: white; font-size: 24px; }

.drop-board { color: #2c3e50; padding-bottom: 5px; right: 0; }
.drop-board:before { right: 15px; }
.results-number { border-bottom: 1px solid rgba(0, 0, 0, .05); height: 30px; line-height: 30px; text-align: center; }
.list-item { display: flex; height: 30px; line-height: 30px; padding-right: 12px; }
.list-item-name { margin-left: 10px; }
.list-item-icon { font-size: 14px; margin: 0 10px 0 12px; }
</style>



// WEBPACK FOOTER //
// src/components/header/ResultsMenu.vue